//TODO: MOVE jQuery Validation TO MVC

/*! jQuery Validation Plugin - v1.11.1 - 3/22/2013\n* https://github.com/jzaefferer/jquery-validation
* Copyright (c) 2013 Jörn Zaefferer; Licensed MIT */(function (t) { t.extend(t.fn, { validate: function (e) { if (!this.length) return e && e.debug && window.console && console.warn("Nothing selected, can't validate, returning nothing."), void 0; var i = t.data(this[0], "validator"); return i ? i : (this.attr("novalidate", "novalidate"), i = new t.validator(e, this[0]), t.data(this[0], "validator", i), i.settings.onsubmit && (this.validateDelegate(":submit", "click", function (e) { i.settings.submitHandler && (i.submitButton = e.target), t(e.target).hasClass("cancel") && (i.cancelSubmit = !0), void 0 !== t(e.target).attr("formnovalidate") && (i.cancelSubmit = !0) }), this.submit(function (e) { function s() { var s; return i.settings.submitHandler ? (i.submitButton && (s = t("<input type='hidden'/>").attr("name", i.submitButton.name).val(t(i.submitButton).val()).appendTo(i.currentForm)), i.settings.submitHandler.call(i, i.currentForm, e), i.submitButton && s.remove(), !1) : !0 } return i.settings.debug && e.preventDefault(), i.cancelSubmit ? (i.cancelSubmit = !1, s()) : i.form() ? i.pendingRequest ? (i.formSubmitted = !0, !1) : s() : (i.focusInvalid(), !1) })), i) }, valid: function () { if (t(this[0]).is("form")) return this.validate().form(); var e = !0, i = t(this[0].form).validate(); return this.each(function () { e = e && i.element(this) }), e }, removeAttrs: function (e) { var i = {}, s = this; return t.each(e.split(/\s/), function (t, e) { i[e] = s.attr(e), s.removeAttr(e) }), i }, rules: function (e, i) { var s = this[0]; if (e) { var r = t.data(s.form, "validator").settings, n = r.rules, a = t.validator.staticRules(s); switch (e) { case "add": t.extend(a, t.validator.normalizeRule(i)), delete a.messages, n[s.name] = a, i.messages && (r.messages[s.name] = t.extend(r.messages[s.name], i.messages)); break; case "remove": if (!i) return delete n[s.name], a; var u = {}; return t.each(i.split(/\s/), function (t, e) { u[e] = a[e], delete a[e] }), u } } var o = t.validator.normalizeRules(t.extend({}, t.validator.classRules(s), t.validator.attributeRules(s), t.validator.dataRules(s), t.validator.staticRules(s)), s); if (o.required) { var l = o.required; delete o.required, o = t.extend({ required: l }, o) } return o } }), t.extend(t.expr[":"], { blank: function (e) { return !t.trim("" + t(e).val()) }, filled: function (e) { return !!t.trim("" + t(e).val()) }, unchecked: function (e) { return !t(e).prop("checked") } }), t.validator = function (e, i) { this.settings = t.extend(!0, {}, t.validator.defaults, e), this.currentForm = i, this.init() }, t.validator.format = function (e, i) { return 1 === arguments.length ? function () { var i = t.makeArray(arguments); return i.unshift(e), t.validator.format.apply(this, i) } : (arguments.length > 2 && i.constructor !== Array && (i = t.makeArray(arguments).slice(1)), i.constructor !== Array && (i = [i]), t.each(i, function (t, i) { e = e.replace(RegExp("\\{" + t + "\\}", "g"), function () { return i }) }), e) }, t.extend(t.validator, { defaults: { messages: {}, groups: {}, rules: {}, errorClass: "error", validClass: "valid", errorElement: "label", focusInvalid: !0, errorContainer: t([]), errorLabelContainer: t([]), onsubmit: !0, ignore: ":hidden", ignoreTitle: !1, onfocusin: function (t) { this.lastActive = t, this.settings.focusCleanup && !this.blockFocusCleanup && (this.settings.unhighlight && this.settings.unhighlight.call(this, t, this.settings.errorClass, this.settings.validClass), this.addWrapper(this.errorsFor(t)).hide()) }, onfocusout: function (t) { this.checkable(t) || !(t.name in this.submitted) && this.optional(t) || this.element(t) }, onkeyup: function (t, e) { (9 !== e.which || "" !== this.elementValue(t)) && (t.name in this.submitted || t === this.lastElement) && this.element(t) }, onclick: function (t) { t.name in this.submitted ? this.element(t) : t.parentNode.name in this.submitted && this.element(t.parentNode) }, highlight: function (e, i, s) { "radio" === e.type ? this.findByName(e.name).addClass(i).removeClass(s) : t(e).addClass(i).removeClass(s) }, unhighlight: function (e, i, s) { "radio" === e.type ? this.findByName(e.name).removeClass(i).addClass(s) : t(e).removeClass(i).addClass(s) } }, setDefaults: function (e) { t.extend(t.validator.defaults, e) }, messages: { required: "This field is required.", remote: "Please fix this field.", email: "Please enter a valid email address.", url: "Please enter a valid URL.", date: "Please enter a valid date.", dateISO: "Please enter a valid date (ISO).", number: "Please enter a valid number.", digits: "Please enter only digits.", creditcard: "Please enter a valid credit card number.", equalTo: "Please enter the same value again.", maxlength: t.validator.format("Please enter no more than {0} characters."), minlength: t.validator.format("Please enter at least {0} characters."), rangelength: t.validator.format("Please enter a value between {0} and {1} characters long."), range: t.validator.format("Please enter a value between {0} and {1}."), max: t.validator.format("Please enter a value less than or equal to {0}."), min: t.validator.format("Please enter a value greater than or equal to {0}.") }, autoCreateRanges: !1, prototype: { init: function () { function e(e) { var i = t.data(this[0].form, "validator"), s = "on" + e.type.replace(/^validate/, ""); i.settings[s] && i.settings[s].call(i, this[0], e) } this.labelContainer = t(this.settings.errorLabelContainer), this.errorContext = this.labelContainer.length && this.labelContainer || t(this.currentForm), this.containers = t(this.settings.errorContainer).add(this.settings.errorLabelContainer), this.submitted = {}, this.valueCache = {}, this.pendingRequest = 0, this.pending = {}, this.invalid = {}, this.reset(); var i = this.groups = {}; t.each(this.settings.groups, function (e, s) { "string" == typeof s && (s = s.split(/\s/)), t.each(s, function (t, s) { i[s] = e }) }); var s = this.settings.rules; t.each(s, function (e, i) { s[e] = t.validator.normalizeRule(i) }), t(this.currentForm).validateDelegate(":text, [type='password'], [type='file'], select, textarea, [type='number'], [type='search'] ,[type='tel'], [type='url'], [type='email'], [type='datetime'], [type='date'], [type='month'], [type='week'], [type='time'], [type='datetime-local'], [type='range'], [type='color'] ", "focusin focusout keyup", e).validateDelegate("[type='radio'], [type='checkbox'], select, option", "click", e), this.settings.invalidHandler && t(this.currentForm).bind("invalid-form.validate", this.settings.invalidHandler) }, form: function () { return this.checkForm(), t.extend(this.submitted, this.errorMap), this.invalid = t.extend({}, this.errorMap), this.valid() || t(this.currentForm).triggerHandler("invalid-form", [this]), this.showErrors(), this.valid() }, checkForm: function () { this.prepareForm(); for (var t = 0, e = this.currentElements = this.elements(); e[t]; t++)this.check(e[t]); return this.valid() }, element: function (e) { e = this.validationTargetFor(this.clean(e)), this.lastElement = e, this.prepareElement(e), this.currentElements = t(e); var i = this.check(e) !== !1; return i ? delete this.invalid[e.name] : this.invalid[e.name] = !0, this.numberOfInvalids() || (this.toHide = this.toHide.add(this.containers)), this.showErrors(), i }, showErrors: function (e) { if (e) { t.extend(this.errorMap, e), this.errorList = []; for (var i in e) this.errorList.push({ message: e[i], element: this.findByName(i)[0] }); this.successList = t.grep(this.successList, function (t) { return !(t.name in e) }) } this.settings.showErrors ? this.settings.showErrors.call(this, this.errorMap, this.errorList) : this.defaultShowErrors() }, resetForm: function () { t.fn.resetForm && t(this.currentForm).resetForm(), this.submitted = {}, this.lastElement = null, this.prepareForm(), this.hideErrors(), this.elements().removeClass(this.settings.errorClass).removeData("previousValue") }, numberOfInvalids: function () { return this.objectLength(this.invalid) }, objectLength: function (t) { var e = 0; for (var i in t) e++; return e }, hideErrors: function () { this.addWrapper(this.toHide).hide() }, valid: function () { return 0 === this.size() }, size: function () { return this.errorList.length }, focusInvalid: function () { if (this.settings.focusInvalid) try { t(this.findLastActive() || this.errorList.length && this.errorList[0].element || []).filter(":visible").focus().trigger("focusin") } catch (e) { } }, findLastActive: function () { var e = this.lastActive; return e && 1 === t.grep(this.errorList, function (t) { return t.element.name === e.name }).length && e }, elements: function () { var e = this, i = {}; return t(this.currentForm).find("input, select, textarea").not(":submit, :reset, :image, [disabled]").not(this.settings.ignore).filter(function () { return !this.name && e.settings.debug && window.console && console.error("%o has no name assigned", this), this.name in i || !e.objectLength(t(this).rules()) ? !1 : (i[this.name] = !0, !0) }) }, clean: function (e) { return t(e)[0] }, errors: function () { var e = this.settings.errorClass.replace(" ", "."); return t(this.settings.errorElement + "." + e, this.errorContext) }, reset: function () { this.successList = [], this.errorList = [], this.errorMap = {}, this.toShow = t([]), this.toHide = t([]), this.currentElements = t([]) }, prepareForm: function () { this.reset(), this.toHide = this.errors().add(this.containers) }, prepareElement: function (t) { this.reset(), this.toHide = this.errorsFor(t) }, elementValue: function (e) { var i = t(e).attr("type"), s = t(e).val(); return "radio" === i || "checkbox" === i ? t("input[name='" + t(e).attr("name") + "']:checked").val() : "string" == typeof s ? s.replace(/\r/g, "") : s }, check: function (e) { e = this.validationTargetFor(this.clean(e)); var i, s = t(e).rules(), r = !1, n = this.elementValue(e); for (var a in s) { var u = { method: a, parameters: s[a] }; try { if (i = t.validator.methods[a].call(this, n, e, u.parameters), "dependency-mismatch" === i) { r = !0; continue } if (r = !1, "pending" === i) return this.toHide = this.toHide.not(this.errorsFor(e)), void 0; if (!i) return this.formatAndAdd(e, u), !1 } catch (o) { throw this.settings.debug && window.console && console.log("Exception occurred when checking element " + e.id + ", check the '" + u.method + "' method.", o), o } } return r ? void 0 : (this.objectLength(s) && this.successList.push(e), !0) }, customDataMessage: function (e, i) { return t(e).data("msg-" + i.toLowerCase()) || e.attributes && t(e).attr("data-msg-" + i.toLowerCase()) }, customMessage: function (t, e) { var i = this.settings.messages[t]; return i && (i.constructor === String ? i : i[e]) }, findDefined: function () { for (var t = 0; arguments.length > t; t++)if (void 0 !== arguments[t]) return arguments[t]; return void 0 }, defaultMessage: function (e, i) { return this.findDefined(this.customMessage(e.name, i), this.customDataMessage(e, i), !this.settings.ignoreTitle && e.title || void 0, t.validator.messages[i], "<strong>Warning: No message defined for " + e.name + "</strong>") }, formatAndAdd: function (e, i) { var s = this.defaultMessage(e, i.method), r = /\$?\{(\d+)\}/g; "function" == typeof s ? s = s.call(this, i.parameters, e) : r.test(s) && (s = t.validator.format(s.replace(r, "{$1}"), i.parameters)), this.errorList.push({ message: s, element: e }), this.errorMap[e.name] = s, this.submitted[e.name] = s }, addWrapper: function (t) { return this.settings.wrapper && (t = t.add(t.parent(this.settings.wrapper))), t }, defaultShowErrors: function () { var t, e; for (t = 0; this.errorList[t]; t++) { var i = this.errorList[t]; this.settings.highlight && this.settings.highlight.call(this, i.element, this.settings.errorClass, this.settings.validClass), this.showLabel(i.element, i.message) } if (this.errorList.length && (this.toShow = this.toShow.add(this.containers)), this.settings.success) for (t = 0; this.successList[t]; t++)this.showLabel(this.successList[t]); if (this.settings.unhighlight) for (t = 0, e = this.validElements(); e[t]; t++)this.settings.unhighlight.call(this, e[t], this.settings.errorClass, this.settings.validClass); this.toHide = this.toHide.not(this.toShow), this.hideErrors(), this.addWrapper(this.toShow).show() }, validElements: function () { return this.currentElements.not(this.invalidElements()) }, invalidElements: function () { return t(this.errorList).map(function () { return this.element }) }, showLabel: function (e, i) { var s = this.errorsFor(e); s.length ? (s.removeClass(this.settings.validClass).addClass(this.settings.errorClass), s.html(i)) : (s = t("<" + this.settings.errorElement + ">").attr("for", this.idOrName(e)).addClass(this.settings.errorClass).html(i || ""), this.settings.wrapper && (s = s.hide().show().wrap("<" + this.settings.wrapper + "/>").parent()), this.labelContainer.append(s).length || (this.settings.errorPlacement ? this.settings.errorPlacement(s, t(e)) : s.insertAfter(e))), !i && this.settings.success && (s.text(""), "string" == typeof this.settings.success ? s.addClass(this.settings.success) : this.settings.success(s, e)), this.toShow = this.toShow.add(s) }, errorsFor: function (e) { var i = this.idOrName(e); return this.errors().filter(function () { return t(this).attr("for") === i }) }, idOrName: function (t) { return this.groups[t.name] || (this.checkable(t) ? t.name : t.id || t.name) }, validationTargetFor: function (t) { return this.checkable(t) && (t = this.findByName(t.name).not(this.settings.ignore)[0]), t }, checkable: function (t) { return /radio|checkbox/i.test(t.type) }, findByName: function (e) { return t(this.currentForm).find("[name='" + e + "']") }, getLength: function (e, i) { switch (i.nodeName.toLowerCase()) { case "select": return t("option:selected", i).length; case "input": if (this.checkable(i)) return this.findByName(i.name).filter(":checked").length }return e.length }, depend: function (t, e) { return this.dependTypes[typeof t] ? this.dependTypes[typeof t](t, e) : !0 }, dependTypes: { "boolean": function (t) { return t }, string: function (e, i) { return !!t(e, i.form).length }, "function": function (t, e) { return t(e) } }, optional: function (e) { var i = this.elementValue(e); return !t.validator.methods.required.call(this, i, e) && "dependency-mismatch" }, startRequest: function (t) { this.pending[t.name] || (this.pendingRequest++ , this.pending[t.name] = !0) }, stopRequest: function (e, i) { this.pendingRequest-- , 0 > this.pendingRequest && (this.pendingRequest = 0), delete this.pending[e.name], i && 0 === this.pendingRequest && this.formSubmitted && this.form() ? (t(this.currentForm).submit(), this.formSubmitted = !1) : !i && 0 === this.pendingRequest && this.formSubmitted && (t(this.currentForm).triggerHandler("invalid-form", [this]), this.formSubmitted = !1) }, previousValue: function (e) { return t.data(e, "previousValue") || t.data(e, "previousValue", { old: null, valid: !0, message: this.defaultMessage(e, "remote") }) } }, classRuleSettings: { required: { required: !0 }, email: { email: !0 }, url: { url: !0 }, date: { date: !0 }, dateISO: { dateISO: !0 }, number: { number: !0 }, digits: { digits: !0 }, creditcard: { creditcard: !0 } }, addClassRules: function (e, i) { e.constructor === String ? this.classRuleSettings[e] = i : t.extend(this.classRuleSettings, e) }, classRules: function (e) { var i = {}, s = t(e).attr("class"); return s && t.each(s.split(" "), function () { this in t.validator.classRuleSettings && t.extend(i, t.validator.classRuleSettings[this]) }), i }, attributeRules: function (e) { var i = {}, s = t(e), r = s[0].getAttribute("type"); for (var n in t.validator.methods) { var a; "required" === n ? (a = s.get(0).getAttribute(n), "" === a && (a = !0), a = !!a) : a = s.attr(n), /min|max/.test(n) && (null === r || /number|range|text/.test(r)) && (a = Number(a)), a ? i[n] = a : r === n && "range" !== r && (i[n] = !0) } return i.maxlength && /-1|2147483647|524288/.test(i.maxlength) && delete i.maxlength, i }, dataRules: function (e) { var i, s, r = {}, n = t(e); for (i in t.validator.methods) s = n.data("rule-" + i.toLowerCase()), void 0 !== s && (r[i] = s); return r }, staticRules: function (e) { var i = {}, s = t.data(e.form, "validator"); return s.settings.rules && (i = t.validator.normalizeRule(s.settings.rules[e.name]) || {}), i }, normalizeRules: function (e, i) { return t.each(e, function (s, r) { if (r === !1) return delete e[s], void 0; if (r.param || r.depends) { var n = !0; switch (typeof r.depends) { case "string": n = !!t(r.depends, i.form).length; break; case "function": n = r.depends.call(i, i) }n ? e[s] = void 0 !== r.param ? r.param : !0 : delete e[s] } }), t.each(e, function (s, r) { e[s] = t.isFunction(r) ? r(i) : r }), t.each(["minlength", "maxlength"], function () { e[this] && (e[this] = Number(e[this])) }), t.each(["rangelength", "range"], function () { var i; e[this] && (t.isArray(e[this]) ? e[this] = [Number(e[this][0]), Number(e[this][1])] : "string" == typeof e[this] && (i = e[this].split(/[\s,]+/), e[this] = [Number(i[0]), Number(i[1])])) }), t.validator.autoCreateRanges && (e.min && e.max && (e.range = [e.min, e.max], delete e.min, delete e.max), e.minlength && e.maxlength && (e.rangelength = [e.minlength, e.maxlength], delete e.minlength, delete e.maxlength)), e }, normalizeRule: function (e) { if ("string" == typeof e) { var i = {}; t.each(e.split(/\s/), function () { i[this] = !0 }), e = i } return e }, addMethod: function (e, i, s) { t.validator.methods[e] = i, t.validator.messages[e] = void 0 !== s ? s : t.validator.messages[e], 3 > i.length && t.validator.addClassRules(e, t.validator.normalizeRule(e)) }, methods: { required: function (e, i, s) { if (!this.depend(s, i)) return "dependency-mismatch"; if ("select" === i.nodeName.toLowerCase()) { var r = t(i).val(); return r && r.length > 0 } return this.checkable(i) ? this.getLength(e, i) > 0 : t.trim(e).length > 0 }, email: function (t, e) { return this.optional(e) || /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i.test(t) }, url: function (t, e) { return this.optional(e) || /^(https?|s?ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(t) }, date: function (t, e) { return this.optional(e) || !/Invalid|NaN/.test("" + new Date(t)) }, dateISO: function (t, e) { return this.optional(e) || /^\d{4}[\/\-]\d{1,2}[\/\-]\d{1,2}$/.test(t) }, number: function (t, e) { return this.optional(e) || /^-?(?:\d+|\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(t) }, digits: function (t, e) { return this.optional(e) || /^\d+$/.test(t) }, creditcard: function (t, e) { if (this.optional(e)) return "dependency-mismatch"; if (/[^0-9 \-]+/.test(t)) return !1; var i = 0, s = 0, r = !1; t = t.replace(/\D/g, ""); for (var n = t.length - 1; n >= 0; n--) { var a = t.charAt(n); s = parseInt(a, 10), r && (s *= 2) > 9 && (s -= 9), i += s, r = !r } return 0 === i % 10 }, minlength: function (e, i, s) { var r = t.isArray(e) ? e.length : this.getLength(t.trim(e), i); return this.optional(i) || r >= s }, maxlength: function (e, i, s) { var r = t.isArray(e) ? e.length : this.getLength(t.trim(e), i); return this.optional(i) || s >= r }, rangelength: function (e, i, s) { var r = t.isArray(e) ? e.length : this.getLength(t.trim(e), i); return this.optional(i) || r >= s[0] && s[1] >= r }, min: function (t, e, i) { return this.optional(e) || t >= i }, max: function (t, e, i) { return this.optional(e) || i >= t }, range: function (t, e, i) { return this.optional(e) || t >= i[0] && i[1] >= t }, equalTo: function (e, i, s) { var r = t(s); return this.settings.onfocusout && r.unbind(".validate-equalTo").bind("blur.validate-equalTo", function () { t(i).valid() }), e === r.val() }, remote: function (e, i, s) { if (this.optional(i)) return "dependency-mismatch"; var r = this.previousValue(i); if (this.settings.messages[i.name] || (this.settings.messages[i.name] = {}), r.originalMessage = this.settings.messages[i.name].remote, this.settings.messages[i.name].remote = r.message, s = "string" == typeof s && { url: s } || s, r.old === e) return r.valid; r.old = e; var n = this; this.startRequest(i); var a = {}; return a[i.name] = e, t.ajax(t.extend(!0, { url: s, mode: "abort", port: "validate" + i.name, dataType: "json", data: a, success: function (s) { n.settings.messages[i.name].remote = r.originalMessage; var a = s === !0 || "true" === s; if (a) { var u = n.formSubmitted; n.prepareElement(i), n.formSubmitted = u, n.successList.push(i), delete n.invalid[i.name], n.showErrors() } else { var o = {}, l = s || n.defaultMessage(i, "remote"); o[i.name] = r.message = t.isFunction(l) ? l(e) : l, n.invalid[i.name] = !0, n.showErrors(o) } r.valid = a, n.stopRequest(i, a) } }, s)), "pending" } } }), t.format = t.validator.format })(jQuery), function (t) { var e = {}; if (t.ajaxPrefilter) t.ajaxPrefilter(function (t, i, s) { var r = t.port; "abort" === t.mode && (e[r] && e[r].abort(), e[r] = s) }); else { var i = t.ajax; t.ajax = function (s) { var r = ("mode" in s ? s : t.ajaxSettings).mode, n = ("port" in s ? s : t.ajaxSettings).port; return "abort" === r ? (e[n] && e[n].abort(), e[n] = i.apply(this, arguments), e[n]) : i.apply(this, arguments) } } }(jQuery), function (t) { t.extend(t.fn, { validateDelegate: function (e, i, s) { return this.bind(i, function (i) { var r = t(i.target); return r.is(e) ? s.apply(r, arguments) : void 0 }) } }) }(jQuery);

// END jQuery Validation

/* http://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript */
(function ($) {
    $.QueryString = (function (a) {
        if (a == "") return {};
        var b = {};
        for (var i = 0; i < a.length; ++i) {
            var p = a[i].split('=');
            if (p.length != 2) continue;
            b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
        }
        return b;
    })(window.location.search.substr(1).split('&'))
})(jQuery);

////if user clicks outside of the top task cards, collapse the top task card accordion
//$(document).on('click', function (e) {
//    //if there are open top task accordion
//    if ($(".cardwithcategory  .toptaskHeader.showless").length) {
//        alert("check 3");
//        // closest return 0 - ancestor not found, outside toptaskheader
//        // closest return 1 - ancestor found, inside toptaskheader

//        if ($(e.target).closest(".toptaskHeader").length === 0) {

//            if ($(e.target).attr("class") === "svg-inline--fa fa-chevron-down fa-w-14 toptaskHeaderIcon") {
//                //do not do anything
//            }
//            else {
//                collapseCards();
//            }
//        }
//    }
//});

// on DOM ready
$(function () {

    if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
        var msViewportStyle = document.createElement("style")
        msViewportStyle.appendChild(
            document.createTextNode(
                "@-ms-viewport{width:auto!important}"
            )
        )
        document.getElementsByTagName("head")[0].appendChild(msViewportStyle)
    }
    
    // Add slide down animation to Bootstrap dropdown when expanding.
    $('.topRequest.dropDown').on('show.bs.dropdown', function () {
        $(this).find('.dropdown-menu').first().stop(true, true).slideDown();
    });

    // Add slide up animation to Bootstrap dropdown when collapsing.
    $('.topRequest.dropDown').on('hide.bs.dropdown', function () {
        $(this).find('.dropdown-menu').first().stop(true, true).slideUp();
    });

    //remove the vertical for the last time period
    $('.VerticalTimelineListComponent div.description:last').removeClass('description').addClass('descriptionLast');
    $('.mainColumnTwoColumn').each(function () {
        $(this).find('.twoColLeft div.description:last').removeClass('description').addClass('descriptionLast');
        $(this).find('.twoColRight div.description:last').removeClass('description').addClass('descriptionLast');
    });

    // add container class for allowable components in the maincoltopcolorblock/maincolbtmcolorblock section to fix width issue.
    $('MajorEvent .QuoteComponentList.colorBlock, .DepartmentHome .QuoteComponentList.colorBlock, .DepartmentPortal .QuoteComponentList.colorBlock, .DepartmentDetail .QuoteComponentList.colorBlock, .Program .QuoteComponentList.colorBlock').each(function () {
        $(this).addClass('container');
    });
    $('MajorEvent .QuoteComponent.colorBlock, .DepartmentHome .QuoteComponent.colorBlock, .DepartmentPortal .QuoteComponent.colorBlock, .DepartmentDetail .QuoteComponent.colorBlock, .Program .QuoteComponent.colorBlock').each(function () {
        $(this).addClass('container');
    });
    $('MajorEvent .ScrollSpyContainerComponent.colorBlock, .DepartmentHome .ScrollSpyContainerComponent.colorBlock, .DepartmentPortal .ScrollSpyContainerComponent.colorBlock, .DepartmentDetail .ScrollSpyContainerComponent.colorBlock, .Program .ScrollSpyContainerComponent.colorBlock').each(function () {
        $(this).addClass('container');
    });

    //for each card container find the children
    $('.CardContainerComponent, .serviceList.cardContainer').each(function () {
        //alert("parent container");

        //auto height for default card components with just title, excerpt and link
        var maxHeight = -1;
        var maxTopSectionHeight = -1;
        var defaultCardWithExtraSpace = false;

        //check if there are ext links or cta, needs extra height
        if ($(this).find(".card.cardwithlink.extlink")[0] || $(this).find(".card.cardwithlink.actionlink")[0] || $(this).find(".card.cardwithlink.extactionlink")[0]) {
            defaultCardWithExtraSpace = true;
        }

        //check if there is a calendar icon
        if ($(this).find(".card.cardwithlink .fa-calendar-alt")[0]) {
            defaultCardWithExtraSpace = true;
        }
        //find the tallest topsection
        $(this).find('.card.cardwithlink .topSection').each(function () {
            maxTopSectionHeight = maxTopSectionHeight > $(this).height() ? maxTopSectionHeight : $(this).height();
            //alert(maxTopSectionHeight);
        });

        //set the tallest top section
        $(this).find('.card.cardwithlink .topSection').each(function () {
            $(this).height(maxTopSectionHeight);
        });

        //find the tallest card in the container
        $(this).find('.card.cardwithlink .content').each(function () {
            maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
        });

        //set the height for the cards
        $(this).find('.card.cardwithlink').each(function () {
            var extraspacing = defaultCardWithExtraSpace ? 60 : 20;
            $(this).height(maxHeight + extraspacing);
        });


        //auto height for btile cards
        //var maxBtileHeight = -1;
        var btileCardWithExtraSpace = false;
        var maxBtilecardTopTitleHeight = -1;
        var maxBtilecardTopExcerptHeight = -1;

        //check if there are ext links or cta, needs extra height
        if ($(this).find(".card.cardwiththumbnailexcerpt .btmright")[0]) {
            btileCardWithExtraSpace = true;
        }

        //check if there are icons (calendar, download or external)
        if ($(this).find(".card.cardwiththumbnailexcerpt .iconrow")[0]) {
            btileCardWithExtraSpace = true;
        }

        $(this).find('.card.cardwiththumbnailexcerpt .topTitle').each(function () {
            maxBtilecardTopTitleHeight = maxBtilecardTopTitleHeight > $(this).height() ? maxBtilecardTopTitleHeight : $(this).height();
        });

        $(this).find('.card.cardwiththumbnailexcerpt .topExcerpt').each(function () {
            maxBtilecardTopExcerptHeight = maxBtilecardTopExcerptHeight > $(this).height() ? maxBtilecardTopExcerptHeight : $(this).height();
        });

        $(this).find('.card.cardwiththumbnailexcerpt .topTitle').each(function () {
            $(this).height(maxBtilecardTopTitleHeight);
        });

        $(this).find('.card.cardwiththumbnailexcerpt .topExcerpt').each(function () {
            $(this).height(maxBtilecardTopExcerptHeight);
        });

        $(this).find('.card.cardwiththumbnailexcerpt .content').each(function () {
            var totspace = maxBtilecardTopTitleHeight + maxBtilecardTopExcerptHeight;
            var extraspacing = btileCardWithExtraSpace ? 30 : 0;
            $(this).height(totspace + extraspacing);
        });

        //auto height for cards with icons
        var maxCardWithIconTopTitleHeight = -1;
        var maxCardWithIconTopExcerptHeight = -1;
        var iconCardWithExtraSpace = false;

        if ($(this).find(".card.cardwithicon.extlink")[0] || $(this).find(".card.cardwithicon.actionlink")[0] || $(this).find(".card.cardwithicon.extactionlink")[0]) {
            iconCardWithExtraSpace = true;
        }

        //check if there are icons (calendar, download or external)
        if ($(this).find(".card.cardwithicon .fa-calendar-alt")[0]) {
            iconCardWithExtraSpace = true;
        }

        $(this).find('.card.cardwithicon .topTitle').each(function () {
            maxCardWithIconTopTitleHeight = maxCardWithIconTopTitleHeight > $(this).height() ? maxCardWithIconTopTitleHeight : $(this).height();
        });

        $(this).find('.card.cardwithicon .topExcerpt').each(function () {
            maxCardWithIconTopExcerptHeight = maxCardWithIconTopExcerptHeight > $(this).height() ? maxCardWithIconTopExcerptHeight : $(this).height();
        });

        $(this).find('.card.cardwithicon .topTitle').each(function () {
            $(this).height(maxCardWithIconTopTitleHeight);
        });

        $(this).find('.card.cardwithicon .topExcerpt').each(function () {
            $(this).height(maxCardWithIconTopExcerptHeight);
        });

        $(this).find('.card.cardwithicon .content').each(function () {
            var totspace = maxCardWithIconTopTitleHeight + maxCardWithIconTopExcerptHeight;
            var extraspacing = iconCardWithExtraSpace ? 20 : 0;
            $(this).height(totspace + extraspacing);
        });

        //auto height for card components with top tasks accordion
        var maxCatTopSectionHeight = -1;

        $(this).find('.card.cardwithcategory .catTopSection').each(function () {
            maxCatTopSectionHeight = maxCatTopSectionHeight > $(this).height() ? maxCatTopSectionHeight : $(this).height();
        });

        $(this).find('.card.cardwithcategory .catTopSection').each(function () {
            $(this).height(maxCatTopSectionHeight + 20);
        });

    });


    //Accordion Font Awesome & update styling - that will slide the content down by implementing a calculated max-height.
    //by default, collapse all accordionss
    $('.accordsFa .accordion-toggle').each(function () {
        $(this).addClass('plus').removeClass('minus');
        $(this).next().addClass('collapsed');
    });

    //for each click, collapse all sibling accordions and toggle the css classes to expand only the clicked accordion
    $('.accordsFa .accordion-toggle').click(function () {
        //if expanded accordion
        if ($(this).hasClass('plus')) {

            $('.accordsFa .accordion-toggle').removeClass('minus').addClass('plus');
            $('.accordsFa .accordionWrapper').slideUp(600);
            $('.accordsFa .accordionWrapper').removeClass('expanded').addClass('collapsed');
            $('.accordsFa .accordionWrapper').css({ 'display': 'none' });
            $('.accordsFa .accordion-toggle').find('.fa-minus').remove();
            $('.accordsFa .accordion-toggle').prepend('<i class="far fa-plus" title="expanded accordion"></i>');

            toggleAccordionsOpen($(this));

            //set the url hash of the accordion's name attribute
            window.location.hash = $(this).attr('name');
            reloadPageForAnchorTag();
            //if collapse accordion 
        } else {
            $(this).find('.fa-minus').remove();
            $(this).prepend('<i class="far fa-plus" title="expanded accordion"></i>');
            $(this).removeClass('minus').addClass('plus');
            $(this).next().slideUp(600);//.delay(300);
            $(this).next().addClass('collapsed').removeClass('expanded');

            toggleAccordionsClose($(this));

            //remove the urlhash but don't jump to the top of the page
            history.pushState(null, null, window.location.href.split('#')[0]);
        }
    });

    // Portal banner external icon. 
    if ($(".bannerDarkGray .bannerTextWithButton")[0] || $(".bannerLightGray .bannerTextWithButton")[0] || $(".bannerLightBlue .bannerTextWithButton")[0]) {
        if ($(this).find(".btn .fa-external-link")[0]) {
            $(".btn").css("padding", "9px 35px 0px 9px");
        }
    }

    $(".tabs").tabs();
    try {
        $("#photos").galleryView({
            panel_width: 702,
            panel_height: 203,
            frame_width: 27,
            frame_height: 26,
            transition_speed: 600,
            transition_interval: 9000,
            overlay_color: 'transparent',
            overlay_text_color: 'black',
            caption_text_color: '#000',
            background_color: '',
            border: 'none',
            nav_theme: 'light',
            easing: 'easeInOutQuad',
            pause_on_hover: true
        });
    }
    catch (e) { }

    slideCount = 5;
    var usedots = true;
    if ($(".slickCarousel").width() > 680 && $(".slickCarousel").width() <= 768) {
        slideCount = 4;
    } else if ($(".slickCarousel").width() > 480 && $(".slickCarousel").width() <= 680) {
        slideCount = 3;
    }
    else if ($(".slickCarousel").width() < 280) {
        slideCount = 1;
        usedots = false;
    }
    else if ($(".slickCarousel").width() <= 480) {
        slideCount = 2;
        usedots = false;
    }


    if ($('.slickCarousel').length > 0) {
        $('.slickCarousel').slick({
            lazyLoad: 'ondemand',
            dots: usedots,
            infinite: false,
            speed: 300,
            slidesToShow: slideCount,
            slidesToScroll: slideCount
        });
        $('.emptyCarousel').parents('.seaCarousel').hide()
    }

    if ($(".memberBio")) {
        $(".toggleArrow").addClass("arrowDown");
        $(".toggleBio").click(function () {
            $(this).next(".memberBio").slideToggle();
            $(this).find(".toggleArrow").toggleClass("arrowDown arrowUp");
        });
    };

    $('a.lightbox').attr("data-toggle", "lightbox");

    $(document).delegate('*[data-toggle="lightbox"]', 'click', function (event) {
        event.preventDefault();
        $(this).ekkoLightbox();
    });

    // remove inline styling in RSS feeds
    $('[id*="feedContainer"]').find('*').removeAttr('style');

    // add contrast stripe to RSS Feeds
    // $(".feedContainer p:even").addClass("even");
    $(".feedContainer ol li:even").addClass("even");
    $(".feedContainer div.rssItem:even").addClass("even");

    $(".stripe tr:even").addClass("even");

    if ($("div#leftNav").length > 0) {
        $("div#leftNav ul ul").hide();

        //show navigation folder's 1st child
        $("div#leftNav ul.navFolder").show();
        $("div#leftNav ul.navFolder ul").show();
        $("div#leftNav ul.navFolder ul ul:not(.navFolder)").hide();

        // show active page and parents of active page
        $("div#leftNav li.activePage a.activePage").parent(this).addClass("activePage").parentsUntil("div#leftNav").addClass("activeParent").show();
        $("div#leftNav li.activePage a.activePage").parent(this).children(this).show();
        $("div#leftNav ul li:first").css("border-top", "0px");

        // clear our negative margin if top level menu item has children
        if ($("div#leftNav > ul#primaryTier > li > ul").length > 0) {
            $("#primaryTier").addClass('primaryTierHasChildren')
        }
        // add font awesome carets to menu items with children 
        $("div#leftNav ul li a").each(function () {
            if ($(this).siblings("ul").length > 0) {
                $(this)
                    .html('<span class="parentLinkTextWrap">' + $(this).text() + '</span>')
                    .prepend('<span class="fa fa-chevron-right"></span')
                    .addClass('hasChildren')
            }
        })
        // adjust caret direction for active pages
        $("div#leftNav ul li.activePage > a > span.fa").removeClass("fa-chevron-right").addClass("fa-chevron-down");
        $("li.activeParent > a > span.fa").removeClass("fa-chevron-right").addClass("fa-chevron-down");
    } else if ($("div#taxNav").length > 0) {
        $("div#taxNav ul").hide();
        $("div#taxNav li.activePage a.activePage").parent(this).addClass("activePage").parentsUntil("div#taxNav").addClass("activeParent").show();
        $("div#taxNav li .activePage a.activePage").parent(this).children(this).show();
        $("div#taxNav li:first").css("border-top", "0px");
    }

    if ($("nav.leftNav2").length > 0) {
        $("nav.leftNav2 ul ul").hide();

        // show active page and parents of active page
        $("nav.leftNav2 li.activePage a.activePage").parent(this).addClass("activePage").parentsUntil("nav.leftNav2").addClass("activeParent").show();
        $("nav.leftNav2 li.activePage a.activePage").parent(this).children(this).show();
        $("nav.leftNav2 ul li:first").css("border-top", "0px");

        // add font awesome carets to items with children 
        $("nav.leftNav2 ul li a").each(function () {
            if ($(this).siblings("ul").length > 0) {
                $(this)
                    .html('<span class="parentLinkTextWrap">' + $(this).text() + '</span>')
                    .prepend('<span class="fa fa-chevron-right"></span')
                    .addClass('hasChildren')
            }
        })
        // clear our negative margin if top level menu item has children
        if ($("nav.leftNav2 > ul.navlist a.hasChildren").length > 0) {
            $(".navlist").addClass('primaryTierHasChildren')
        }
        // adjust caret direction for active pages
        $("nav.leftNav2 ul li.activePage > span.fa").removeClass("fa-chevron-right").addClass("fa-chevron-down");
        $("li.activeParent > span.fa").removeClass("fa-chevron-right").addClass("fa-chevron-down");
    }

    // Event handler for Mayor's Priorities
    $("#seagovBannerAction, #seagovBanner_close").click(function () {
        $("#seagovPriorityPanel").toggle("drop", { direction: "up", opacity: 0.9 }, 1000, function () {
            if ($("#seagovPriorityPanel").is(':visible')) {
                $("#seagovBannerAction").html("<span class=\"ui-icon ui-icon-close\" style=\"float:right\"></span><span style=\"text-decoration: underline;float:right\">Close</span>");
            } else {
                $("#seagovBannerAction").html("<span class=\"ui-icon ui-icon-triangle-1-s\" style=\"float:right\"></span><span style=\"text-decoration: underline;float:right\">Learn More</span>")
            }
        });
    });

    $("div.seagovTopicStyle").hover(
        function () {
            $(this).addClass("seagovTopicStyleHover").fadeIn(5000);
        },
        function () {
            $(this).stop(0, 0);
            $(this).removeClass("seagovTopicStyleHover");
        }
    );

    $('div.videoIndex > a.seekItem').click(this, function () {
        jwplayer().seek($(this).data('seek')); return false;
    });

    if ($.QueryString["stop"] != null) {
        jwplayer().on('time', function (x) {
            if (x.position >= TimeToSeconds($.QueryString["stop"])) {
                jwplayer().stop();
            }
        });
    }

    $("input[name=Email],input[name=email]").attr("title", "Email Address");

    $('#seagovNav').remove();

    /* accessibility bandaids */
    $('td[valign="top"]').css('vertical-align', 'top').removeAttr('valign');
    $('td[align="left"]').removeAttr('align');
    $('table[border="0"]').removeAttr('border');
    $('td[align="center"]').css('text-align', 'center').removeAttr('align');
});
// DOM Ready end

function submitenter(myfield, e) {
    var keycode;

    if (window.event) keycode = window.event.keyCode;
    else if (e) keycode = e.which;
    else return true;

    if (keycode == 13) {
        if (myfield.id == "Text1") {
            document.forms['tester'].g1.click()
        } else {
            document.forms['tester'].g2.click()
        }
        return false;
    } else {
        return true;
    }
}

//Truncate text function
function truncStr(str, len) {
    if (str.length > len) {
        str = str.substr(0, len);
        str = str.substr(0, str.lastIndexOf(" ")) + "...";
    }
    document.write(str);
}

//Date Format from RSS format
function checkEntryDate(entryItem) {
    newEntryDate = dateFormat(entryItem);
    splitDate = newEntryDate.split("/");
    var myDate = new Date();
    myDate.setFullYear(splitDate[2], splitDate[0] - 1, splitDate[1]);
    today = new Date();
    today.setDate(today.getDate() - 1)
    newEntryDate = newEntryDate;
    document.write(newEntryDate);
}

function checkEntryDateSm(entryItem) {
    newEntryDate = dateFormat(entryItem);
    splitDate = newEntryDate.split("/");
    var myDate = new Date();
    myDate.setFullYear(splitDate[2], splitDate[0] - 1, splitDate[1]);
    today = new Date();
    today.setDate(today.getDate() - 1)
    newEntryDate = '';
    return newEntryDate;
}

function dateFormat(dateObj) {

    var strDate = dateObj.slice(5, dateObj.length - 15);
    strDate = strDate.split(" ");
    switch (strDate[1].toUpperCase()) {
        case "JAN":
            strDate[1] = "01";
            break;
        case "FEB":
            strDate[1] = "02";
            break;
        case "MAR":
            strDate[1] = "03";
            break;
        case "APR":
            strDate[1] = "04";
            break;
        case "MAY":
            strDate[1] = "05";
            break;
        case "JUN":
            strDate[1] = "06";
            break;
        case "JUL":
            strDate[1] = "07";
            break;
        case "AUG":
            strDate[1] = "08";
            break;
        case "SEP":
            strDate[1] = "09";
            break;
        case "OCT":
            strDate[1] = "10";
            break;
        case "NOV":
            strDate[1] = "11";
            break;
        case "DEC":
            strDate[1] = "12";
            break;
        default:
    }

    var newDate = strDate[1] + "/" + strDate[0] + "/" + strDate[2];
    var PostDate = new Date(strDate[2], strDate[1] - 1, strDate[0]);
    var myDate = new Date();
    myDate.setFullYear(strDate[2], strDate[1] - 1, "20" + strDate[0]);
    HoldDate = new Date();
    return newDate;
}

function video(id) {
    loC = "http://www.seattlechannel.org/videos/video.asp?ID=" + id
    window.open(loC, "viewer", "location=no,status=yes,scrollbars=no,resizable=yes,width=800,height=400")
}

function submitenter(myfield, e) {
    var keycode;
    if (window.event) {
        keycode = window.event.keyCode;
    } else if (e) {
        keycode = e.which;
    } else {
        return true;
    }
    if (keycode == 13) {
        if (myfield.id == "addr" && myfield.value !== "") {
            formatAddress();
        }
        return false;
    }
}

function TimeToSeconds(inputTime) {
    var timeVals = inputTime.split(':');
    var mins = 0, hours = 0, seconds = 0;
    if (timeVals.length == 0) {
        return 0;
    }
    if (timeVals.length == 1) {
        seconds = parseInt(timeVals[0]);
    }
    if (timeVals.length == 2) {
        mins = parseInt(timeVals[0]);
        seconds = parseInt(timeVals[1]);
    }
    if (timeVals.length == 3) {
        hours = parseInt(timeVals[0]);
        mins = parseInt(timeVals[1]);
        seconds = parseInt(timeVals[2]);
    }
    return (hours * 3600) + (mins * 60) + seconds;
}

// SolarWind Service
var _prum = [['id', '54d39fd1abe53d404a5d1d56'],
['mark', 'firstbyte', (new Date()).getTime()]];
(function () {
    var s = document.getElementsByTagName('script')[0]
        , p = document.createElement('script');
    p.async = 'async';
    p.src = '//rum-static.pingdom.net/prum.min.js';
    s.parentNode.insertBefore(p, s);
})();



/* loads new podcast into podcastplayer, takes list of arguments. Sends a GA request */
function loadJWPodcastPlayer7(myFile, myImage, description, notice, title, pubdate, duration, msn, hasHD, xid, closedCaption) {

    // if ($('.videoIndex').length > 0) {
    //     $('.videoIndex').empty();
    // }

    // //display podcast
    // $('.podcastContainer').show();

    // var dur = $('.podcastDuration').text(duration);
    // $('.podcastDate').html(pubdate).append(dur);
    // $('.podcastTitle').html(title);
    // $('.podcastDescription').html(description);
    // $('.podcastMsn').html(msn);
    // var podcastImage =  "<img id='podcastImage'src='" + myImage + "'/>";
    // $("#podcastImage img").remove();
    // $('#podcastImage').prepend(podcastImage);

    // try {
    //     podcastplayerInstance.remove();
    // }
    // catch (e) {
    //     try {
    //         var id = podcastplayerInstance.id;
    //         podcastplayerInstance.remove();
    //         $('#' + id).attr('id', 'jwplayerID');
    //     }
    //     catch (e2) { }
    // }

    // podcastplayerInstance = jwplayer("jwplayerID");
    // podcastplayerInstance.setup({

    //         file: myFile,
    //         primary: "html5",
    //         title: title,
    //         displaytitle: false,
    //         width: 300,
    //         height: 40,
    //         ga: {
    //             idstring: "title"
    //         }

    //     });

    //     podcastplayerInstance.on('complete', function () {

    // });
    // podcastplayerInstance.on('error', function (message) {
    //     $("#jwplayerID" ).text( "There was an error with the podcast." );
    // });
    // podcastplayerInstance.on('setupError', function () {
    //     //ex file is missing error
    //     $( "#jwplayerID" ).text( "There was an error with podcast set up." );
    // });
    // podcastplayerInstance.on('ready', function () {
    //     $('body, html').animate({
    //         scrollTop: (0)
    //     }, 1000);
    //     //podcastplayerInstance.play();
    // });

    // //hide default podcast player
    //  $("#listenNowID").show();
    //  $("#playerContainer").hide();

    // //toggle default podcast player
    // $("#listenNowID").click(function(){
    //     //show default podcast player
    //     $("#playerContainer").show();
    //     //hide default listen now
    //     $("#listenNowID").hide();
    // });

    // History.replaceState(null, title, '?podcastid=' + xid)
    return false;

};


/* loads new video into videoplayer, takes list of arguments. Sends a GA request */
/* video items from the carousel use this function */
function loadJWPlayer7(myFile, myImage, description, title, pubdate, duration, msn, hasHD, xid, closedCaption, podcastTitle, podcastDate, podcastDuration, podcastDescription, podcastNotice, podcastMsn, podcastFeatureImage, podcastFileStandard) {

    if ($('.videoIndex').length > 0) {
        $('.videoIndex').empty();
    }
    $(".programImage .overlayBox").hide();
    $(".VideoComponent .overlayBox").hide();
    var dur = $('.episodeDuration').text(duration);
    $('.episodeDate').html(pubdate).append(dur);
    $('.episodeTitle').html(title);
    $('.episodeDescription').html(description);
    $('.msn').html(msn);
    $('.overlayBox .videoTitle').text(title);
    if ($('img#videoError').length) {
        $('img#videoError').hide();
        $('#' + playerInstance.id).show();
    }

    //populate podcast when the a video w a podcast in the carousel is clicked
    var dur = $('.podcastDuration').text(podcastDuration);
    $('.podcastDate').html(podcastDate).append(dur);
    $('.podcastTitle').html(podcastTitle);
    $('.podcastDescription').html(podcastDescription);
    $('.podcastNotice').html(podcastNotice);
    $('.podcastMsn').html(podcastMsn);

    var embedCode = "<iframe src=\"" + location.protocol + "//" + location.host + "/embedvideoplayer?videoid=" + xid + "\" frameborder=\"0\" scrolling=\"no\" style=\"min-height: 270px; min-width: 480px\" ></iframe>";
    var shareLink = location.protocol + "//" + location.host + location.pathname + "?videoid=" + xid;
    try {
        playerInstance.remove();
    }
    catch (e) {
        try {
            var id = playerInstance.id;
            playerInstance.remove();
            $('#' + id).attr('id', 'vidPlayer');
        }
        catch (e2) { }
    }
    var sourceFiles = [{ file: myFile, label: "360p SD" }];
    var closedCaptionPath = "documents/seattlechannel/closedcaption/" + closedCaption;
    var closedCaptionFile = [{
        file: closedCaptionPath,
        label: "On",
        kind: "captions",
        "default": true
    }]
    if (hasHD) {
        sourceFiles.push({ file: myFile.replace(".mp4", "HD.mp4"), label: "720p HD" });
    }

    playerInstance = jwplayer("vidPlayer");
    if (closedCaption != "") {
        playerInstance.setup({
            sources: sourceFiles,
            image: myImage,
            primary: "html5",
            title: title,
            displaytitle: false,
            tracks: closedCaptionFile,
            sharing: {
                code: encodeURI(embedCode),
                link: shareLink
            },
            ga: {
                idstring: "title"
            }
        });
    }
    else {
        playerInstance.setup({

            sources: sourceFiles,
            image: myImage,
            primary: "html5",
            title: title,
            displaytitle: false,

            sharing: {
                code: encodeURI(embedCode),
                link: shareLink
            },
            ga: {
                idstring: "title"
            }

        });
    };


    playerInstance.on('complete', function () {
        $('#vidPlayer').append($('.overlayBox'));
    });
    playerInstance.on('play', function () {
        $('.overlayBox').hide();
    });

    playerInstance.on('pause', function () {
        $('.overlayBox').show();
    });

    playerInstance.on('error', function (message) {
        if (playerInstance.getPlaylist()[0].sources.length > 1) {
            playerInstance.load({ file: playerInstance.getPlaylist()[0].file });
            playerInstance.play();
        }
        else {
            if (!$('img#videoError').length) {
                $('#vidPlayer').after("<img id='videoError' class='img-responsive' src='images/seattlechannel/videoimages/channelGeneric.jpg' alt='There was an error with the video' />");
            }
            else {
                $('img#videoError').show();
            }
            $('#vidPlayer').hide();
        }
    });
    playerInstance.on('setupError', function () {
        if (!$('img#videoError').length) {
            $('#vidPlayer').after("<img id='videoError' class='img-responsive' src='images/seattlechannel/videoimages/channelGeneric.jpg' alt='There was an error with set up' />");
        }
        else {
            $('img#videoError').show();
        }
        $('#vidPlayer').hide();
    });
    playerInstance.on('ready', function () {
        $(".programImage .overlayBox").show();
        $(".VideoComponent .overlayBox").show();
        $('body, html').animate({
            scrollTop: (0)
        }, 1000);
        //playerInstance.play();
    })

    playerInstance.addButton(
        "/images/seattlechannel/download.png",
        "Download Video",

        function () {
            window.location.href = playerInstance.getPlaylistItem()['file'];
        },
        'downloadvidPlayer'
    );

    //populate podcast when the a video w a podcast in the carousel is clicked
    //hide podcast container if there's none
    if (podcastTitle == '') {
        $('.podcastContainer').hide();
    }
    else {

        var dur = $('.podcastDuration').text(podcastDuration);
        $('.podcastDate').html(podcastDate).append(dur);
        $('.podcastTitle').html(podcastTitle);
        $('.podcastDescription').html(podcastDescription);
        $('.podcastNotice').html(podcastNotice);
        $('.podcastMsn').html(podcastMsn);

        podcastFileStandard = "http://video.seattle.gov:8080/media/" + podcastFileStandard;

        $('.podcastContainer').show();
        podcastImage = "<img id='podcastImage'src='images/" + podcastFeatureImage + "'/>";
        $("#podcastImage img").remove();
        $('#podcastImage').prepend(podcastImage);

        var podcastplayerInstance = jwplayer("jwplayerID");
        podcastplayerInstance.setup({

            file: podcastFileStandard,
            primary: "html5",
            title: podcastTitle,
            displaytitle: false,
            width: 300,
            height: 40,
            ga: {
                idstring: "title"
            }

        });

        podcastplayerInstance.on('complete', function () {
        });

        podcastplayerInstance.on('error', function (message) {
            $("#jwplayerID").text("There was an error with podcast.");
        });

        podcastplayerInstance.on('setupError', function () {
            //ex file is missing error
            $("#jwplayerID").text("There was an error with podcast set up.");
        });
    }

    //hide podcast player
    $("#listenNowID").show();
    $("#playerContainer").hide();

    //toggle podcast player
    $("#listenNowID").click(function () {
        //show podcast player
        $("#playerContainer").show();
        //hide default listen now
        $("#listenNowID").hide();
    });

    History.replaceState(null, title, '?videoid=' + xid)
    return false;

};

function loadJWPlayer7Index(msn, year) {
    if ($('.videoIndex').length > 0) {
        var videoIndex = $('.videoIndex');
    }
    else {
        var videoIndex = $('<div/>').addClass("videoIndex");
    }
    indexPath = location.protocol + "//" + location.host + "/documents/seattlechannel/indexing/";
    if (year > 2015) {
        indexPath = indexPath + year + "/" + msn + ".xml";
    }
    else {
        indexPath = indexPath + msn + ".xml";
    }

    var reqPath = indexPath;
    $.ajax(reqPath)
        .done(function (data, textStatus, jqXHR) {
            var indexLinks = "<div class=\"indexHeading\">Advance to a specific part </div>";
            $(data).find('[start]').each(function (index, item) {
                var seekTime = TimeToSeconds($(item).attr('start'));
                indexLinks += "<a class=\"seekItem\" onclick=\"playerInstance.seek($(this).data('seek')); return false;\" href=\"#\" data-seek=\"" + seekTime + "\" >" + $(item).parent().find('title').text() + " - " + $(item).attr('start') + "</a>";
            });
            videoIndex.html(indexLinks);
        })
        .fail(function (jqXHR, textStatus, errorThrown) {
            videoIndex.empty();
        });
}

function toggleAccordionsOpen(accordion) {
    accordion.find('.fa-plus').remove();
    accordion.prepend('<i class="far fa-minus" title="collapsed accordion"></i>');
    accordion.removeClass('plus').addClass('minus');
    accordion.next().slideDown(600);
    accordion.next().addClass('expanded').removeClass('collapsed');
}

function toggleAccordionsClose(accordion) {
    accordion.find('.fa-minus').remove();
    accordion.prepend('<i class="far fa-plus" title="expanded accordion"></i>');
    accordion.removeClass('minus').addClass('plus');
    accordion.next().slideUp(600);//.delay(300);
    accordion.next().addClass('collapsed').removeClass('expanded');
}